import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config

  return {
    default: {
      tooltip: {
        ...tokens.fontBodyM,
        background: tokens.bgColorInverse,
        border: '1px solid #1e1e1e',
        borderRadius: '2px',
        boxShadow: tokens.elevationLow,
        maxWidth: '200px',
        paddingBlock: '6px',
        paddingInline: '12px',
      },
    },
  } as const
}
